/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import moment from "moment";
import { Link } from "react-router-dom";
import Authorization from "../../../../../component/Authorization";
import { mConstants } from "../../../../../helper/constants";
import { IoPagination } from "../../../../../helper/pagination";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { PromotionUI } from "../../entity/promotion.model";
import { promotionService } from "../../service/promotion.service";

export interface PromotionTableProps {
  pagination: IoPagination<PromotionUI>;
  onChange: (page: number, pageSize: number) => void;
}

function PromotionTable(props: PromotionTableProps) {
  const promotionTableColumns: ColumnsType<PromotionUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Эхлэх огноо",
      dataIndex: "startDate",
      key: "startDate",
      render: (startDate: string) =>
        moment(startDate).format(mConstants.DATE_FORMAT),
    },
    {
      title: "Дуусах огноо",
      dataIndex: "endDate",
      key: "endDate",
      render: (endDate: string) =>
        moment(endDate).format(mConstants.DATE_FORMAT),
    },
    {
      title: "Суваг",
      dataIndex: "channels",
      key: "channels",
      render: (value: string[]) => value.join(", "),
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: PromotionUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      to={`/promotions/${record.uuid}`}
                      key={`edit-${record.uuid}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                } else if (action.type === ActionType.delete) {
                  return (
                    <Authorization roles={["promotion-full"]}>
                      <a
                        href="#"
                        key={`delete-${record.uuid}`}
                        className="dropdown-item"
                        onClick={() => {
                          Modal.confirm({
                            title: "Баталгаажуулах",
                            content: "Та устгахдаа итгэлтэй байна уу?",
                            okText: "Үргэлжлүүлэх",
                            cancelText: "Хаах",
                            onOk: () => {
                              promotionService
                                .deletePromotion(record.uuid!)
                                .then(() => props.onChange(1, 10))
                                .catch((e) => console.error(e));
                            },
                          });
                        }}
                      >
                        <i className={action.icon}></i>
                        {action.text}
                      </a>
                    </Authorization>
                  );
                } else {
                  return <></>;
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];

  const PromotionUIs: PromotionUI[] = props.pagination.content.map(
    (promotion, index) => {
      const actions: Action[] = [
        { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
        { icon: "icon-bin2", text: "Устгах", type: ActionType.delete },
      ];
      return {
        ...promotion,
        actions: actions,
        index: index + 1,
        key: index,
      };
    }
  );

  return (
    <Table
      className="table table-responsive"
      columns={promotionTableColumns}
      dataSource={PromotionUIs}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.totalElements,
        onChange: props.onChange,
      }}
    />
  );
}
export default PromotionTable;
